// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as ButtonPhased from "../../resources/actions/ButtonPhased.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ProductPriceTableCell from "../Product/ProductPriceTableCell.res.js";
import * as PricePurchaseTableEditCell from "./PricePurchaseTableEditCell.res.js";
function PricePurchaseTableEditCellWrapper(props) {
  let __compact = props.compact;
  let __disabled = props.disabled;
  let bulkUnit = props.bulkUnit;
  let formattedPurchasePrice = props.formattedPurchasePrice;
  let disabled = __disabled !== undefined ? __disabled : false;
  let compact = __compact !== undefined ? __compact : false;
  let match = React.useState(() => formattedPurchasePrice);
  let setFormattedValue = match[1];
  let match$1 = React.useState(() => false);
  let setFocused = match$1[1];
  let onFocus = () => setFocused(param => true);
  let onBlur = () => setFocused(param => false);
  let match$2 = Hover.use(undefined, undefined, undefined);
  let ref = match$2[0];
  let onChange = React.useCallback(value => setFormattedValue(param => I18n.currencyFormat(undefined, "EUR", 3, 3, value) + Stdlib_Option.mapOr(bulkUnit, "", unit => "/" + unit)), [bulkUnit]);
  let onPressButton = param => setFocused(param => true);
  let newrecord = {
    ...{
      style: {
        marginLeft: "-10px"
      }
    }
  };
  return JsxRuntime.jsx(Inline.make, {
    children: JsxRuntime.jsx("div", (newrecord.ref = Primitive_option.some(ref), newrecord.children = match$1[0] ? JsxRuntime.jsx(PricePurchaseTableEditCell.make, {
      value: props.value,
      minRetailPrice: props.minRetailPrice,
      bulkUnit: bulkUnit,
      variantId: props.variantId,
      autoFocused: true,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur
    }) : JsxRuntime.jsx(ButtonPhased.make, {
      children: JsxRuntime.jsx(ProductPriceTableCell.make, {
        value: match[0],
        size: compact ? "xsmall" : "normal"
      }),
      hovered: match$2[1],
      disabled: disabled,
      onPress: onPressButton,
      ref: ref
    }), newrecord))
  });
}
let make = React.memo(PricePurchaseTableEditCellWrapper);
export { make };
/* make Not a pure module */